const POINTER_SIZE = 9;

/**
 * Speech-bubble nib at the note end of a stem.
 * `incoming` is the previous waypoint so the tip points back along the line.
 */
export function buildNotePointerPoints(end, incoming, size = POINTER_SIZE) {
  if (!end || !incoming) return [];
  const dx = end.x - incoming.x;
  const dy = end.y - incoming.y;
  const half = size * 0.85;
  const inset = 1.5;

  if (Math.abs(dy) >= Math.abs(dx)) {
    if (dy >= 0) {
      return [
        { x: end.x, y: end.y - size },
        { x: end.x - half, y: end.y + inset },
        { x: end.x + half, y: end.y + inset },
      ];
    }
    return [
      { x: end.x, y: end.y + size },
      { x: end.x - half, y: end.y - inset },
      { x: end.x + half, y: end.y - inset },
    ];
  }
  if (dx >= 0) {
    return [
      { x: end.x - size, y: end.y },
      { x: end.x + inset, y: end.y - half },
      { x: end.x + inset, y: end.y + half },
    ];
  }
  return [
    { x: end.x + size, y: end.y },
    { x: end.x - inset, y: end.y - half },
    { x: end.x - inset, y: end.y + half },
  ];
}

export function buildNotePointerPolygon(end, incoming, size = POINTER_SIZE) {
  return buildNotePointerPoints(end, incoming, size)
    .map((p) => `${p.x},${p.y}`)
    .join(' ');
}
